export default "__VITE_ASSET__z3nj6lJi__"